import BaseTextInputEditor from '../BaseTextInputEditor';

export class TextInputEditor extends BaseTextInputEditor {
  getCellCustomStyle(): string {
    return 'custom-text-editor';
  }
}
